ClubService.$inject = ['API', '_', '$rootScope', '$uibModal', 'Backoffice'];

/* @ngInject */
function ClubService(API, _, $rootScope, $uibModal, Backoffice) {
    var Club = {
        openPlayersModal: ({ onPhoneSelect, is_from_backoffice = false }) => {
            $uibModal.open({
                template: `
            <div class="modal-header">
                <button type="button" class="close" aria-label="Close" ng-click="$modal.close()">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3 class="modal-title">Jugadores</h3>
            </div>
            <div class="modal-body">
                <div players-v3-selector on-player-select="$modal.onPlayerSelect($player)"></div>
            </div>
          `,
                size: 'lg',
                backdrop: false,
                controller: [
                    '$uibModalInstance',
                    function ($uibModalInstance) {
                        this.close = () => $uibModalInstance.close();
                        this.onPlayerSelect = (player) => {
                            onPhoneSelect && onPhoneSelect(player.phone);
                            this.close();
                        };
                    },
                ],
                controllerAs: '$modal',
                windowClass: `sub-zindex-1 ${
                    is_from_backoffice ? 'backoffice-zIndex' : ''
                }`,
            });
        },

        // openPlayersBookingModal: ({user, onPhoneSelect}) => {
        //     // console.log(user);
        //     $uibModal.open({
        //         template: require('../../views/booking/players_offline.modal.html'),
        //         size: 'lg',
        //         backdrop: false,
        //         controller: ['$uibModalInstance', function ($uibModalInstance) {
        //             this.close = () => $uibModalInstance.close();
        //             this.onPhoneSelect = (phone) => {
        //                 onPhoneSelect && onPhoneSelect(phone);
        //                 console.log(phone);
        //                 alert(1);
        //                 //this.close();
        //             };
        //         }],
        //         controllerAs: '$modal',
        //         windowClass: 'sub-zindex-1',
        //     });
        // }
    };

    const featureKey = 'disable_bookings_calendar';
    const cashReportEmployeeRestrictionFeatureKey =
        'cash_report_employee_restriction';
    const salesPurchasesReportEmployeeRestrictionFeatureKey =
        'sales_purchases_report_employee_restriction';
    const cashRegisterReconciliationFeatureKey = 'cash_register_reconciliation';
    const labSportclubFeatureKey = 'lab_sportclub';
    const turnTypesFeatureKey = 'turn_types';
    const buffetFeatureKey = 'buffet_enabled';

    function evaluateFeatureFlag(features, key, userAttributes) {
        if (!features[key]) return null;
        const feature = features[key];
        if (!feature.rules) return feature.defaultValue;
        return feature.rules.some((rule) => {
            if (!rule.condition) return false;
            return Object.entries(rule.condition).some(([attr, value]) => {
                if (!value || !value.$in || !Array.isArray(value.$in))
                    return false;
                return value.$in.includes(userAttributes[attr]);
            });
        });
    }

    _.extend(Club, {
        /**
         * Restangular API for the current Club
         * @property {Restangular Club}
         */
        API: null,
        /**
         * Restangular API for the current Club's cash movements
         */
        CashMovementsAPI: null,
        /**
         * Install Service
         * @method install
         * @param  {Object} data Club response
         */
        install: function (data) {
            _.extend(Club, data);

            Club.API = API.one('sportclubs', data.id);

            Club.CashMovementsAPI = Club.API.all('cash-movements');

            const userAttributes = { sportclub_id: data.id };
            const features = data.growthbookData?.features || {};

            Club[featureKey] = evaluateFeatureFlag(
                features,
                featureKey,
                userAttributes,
            );
            Club[cashReportEmployeeRestrictionFeatureKey] = evaluateFeatureFlag(
                features,
                cashReportEmployeeRestrictionFeatureKey,
                userAttributes,
            );

            Club[salesPurchasesReportEmployeeRestrictionFeatureKey] =
                evaluateFeatureFlag(
                    features,
                    salesPurchasesReportEmployeeRestrictionFeatureKey,
                    userAttributes,
                );
            Club[cashRegisterReconciliationFeatureKey] = evaluateFeatureFlag(
                features,
                cashRegisterReconciliationFeatureKey,
                userAttributes,
            );
            Club[labSportclubFeatureKey] = evaluateFeatureFlag(
                features,
                labSportclubFeatureKey,
                userAttributes,
            );
            Club[turnTypesFeatureKey] = evaluateFeatureFlag(
                features,
                turnTypesFeatureKey,
                userAttributes,
            );
            Club[buffetFeatureKey] = evaluateFeatureFlag(
                features,
                buffetFeatureKey,
                userAttributes,
            );
            Club.cashRegisterReconciliationState = {
                isActivated: false,
                hasOpenReconciliation: false,
                currentReconciliationId: null,
                loading: Club[cashRegisterReconciliationFeatureKey] === true,
                error: false,
            };

            if (Club.hasCashRegisterReconciliationEnabled()) {
                window.removeEventListener(
                    'cash-reconciliation-status-changed',
                    Club.cashReconciliationStatusHandler,
                );
                Club.cashReconciliationStatusHandler = (event) =>
                    Club.setCashRegisterReconciliationState(event.detail);
                window.addEventListener(
                    'cash-reconciliation-status-changed',
                    Club.cashReconciliationStatusHandler,
                );
                Club.initializeCashRegisterReconciliationStatus();
            }

            // Install rootscope helpers
            $rootScope.app.club = {
                name: data.name,
            };

            $rootScope.app.club.hasNewBookingsCalendarEnabled = function () {
                return Club[featureKey] !== true;
            };

            $rootScope.app.club.hasCashReportEmployeeRestrictionEnabled =
                function () {
                    return (
                        Club[cashReportEmployeeRestrictionFeatureKey] === true
                    );
                };

            $rootScope.app.club.hasSalesPurchasesReportEmployeeRestrictionEnabled =
                function () {
                    return (
                        Club[
                            salesPurchasesReportEmployeeRestrictionFeatureKey
                        ] === true
                    );
                };

            $rootScope.app.club.hasCashRegisterReconciliationEnabled =
                Club.hasCashRegisterReconciliationEnabled;
            $rootScope.app.club.hasLabSportclubEnabled =
                Club.hasLabSportclubEnabled;
            $rootScope.app.club.hasTurnTypesEnabled =
                Club.hasTurnTypesEnabled;
            $rootScope.app.club.hasBuffetEnabled = Club.hasBuffetEnabled;
            $rootScope.app.club.isCashRegisterReconciliationActivated =
                Club.isCashRegisterReconciliationActivated;
            $rootScope.app.club.hasOpenCashReconciliation =
                Club.hasOpenCashReconciliation;
            $rootScope.app.club.shouldBlockCashMovements =
                Club.shouldBlockCashMovements;
        },
        /**
         * Update Club service data
         * @method update_club
         * @param  {Ajax Response} response [description]
         * @param  {Ajax Request Data} data [description]
         * @chainable
         */
        update: function (response, data, except) {
            except = except || ['code'];
            var keys = _.without(_.keys(data), except);
            _.extend(Club, _.pick(response, keys));
            return Club;
        },

        /**
         * Checks if the new bookings calendar feature is enabled on growthbook
         * @method hasNewBookingsCalendarEnabled
         * @returns {Boolean} True if the new bookings calendar feature is enabled
         */
        hasNewBookingsCalendarEnabled: function () {
            return Club[featureKey] !== true;
        },

        hasCashReportEmployeeRestrictionEnabled: function () {
            return Club[cashReportEmployeeRestrictionFeatureKey] === true;
        },

        hasSalesPurchasesReportEmployeeRestrictionEnabled: function () {
            return (
                Club[salesPurchasesReportEmployeeRestrictionFeatureKey] === true
            );
        },

        hasCashRegisterReconciliationEnabled: function () {
            return Club[cashRegisterReconciliationFeatureKey] === true;
        },

        hasLabSportclubEnabled: function () {
            return Club[labSportclubFeatureKey] === true;
        },

        hasTurnTypesEnabled: function () {
            return Club[turnTypesFeatureKey] === true;
        },

        hasBuffetEnabled: function () {
            return Club[buffetFeatureKey] === true;
        },

        isCashRegisterReconciliationActivated: function () {
            return Club.cashRegisterReconciliationState?.isActivated === true;
        },

        hasOpenCashReconciliation: function () {
            return (
                Club.cashRegisterReconciliationState?.hasOpenReconciliation ===
                true
            );
        },

        shouldBlockCashMovements: function () {
            return (
                Club.hasCashRegisterReconciliationEnabled() &&
                (Club.cashRegisterReconciliationState?.loading === true ||
                    Club.cashRegisterReconciliationState?.error === true ||
                    (Club.isCashRegisterReconciliationActivated() &&
                        !Club.hasOpenCashReconciliation()))
            );
        },

        initializeCashRegisterReconciliationStatus: function () {
            if (!Club.hasCashRegisterReconciliationEnabled()) {
                return Promise.resolve();
            }
            Club.setCashRegisterReconciliationState({
                ...Club.cashRegisterReconciliationState,
                loading: true,
                error: false,
            });
            return Backoffice.api
                .initializeCashReconciliationStatus()
                .then((status) => {
                    Club.setCashRegisterReconciliationState({
                        isActivated: status.enabled,
                        hasOpenReconciliation: status.has_open_reconciliation,
                        currentReconciliationId:
                            status.current_reconciliation_id,
                        loading: false,
                        error: false,
                    });
                })
                .catch(() => {
                    Club.setCashRegisterReconciliationState({
                        ...Club.cashRegisterReconciliationState,
                        loading: false,
                        error: true,
                    });
                });
        },

        refreshCashRegisterReconciliationStatus: function () {
            if (!Club.hasCashRegisterReconciliationEnabled()) {
                return Promise.resolve();
            }
            return Backoffice.api.getCashReconciliationStatus();
        },

        setCashRegisterReconciliationState: function (state) {
            Club.cashRegisterReconciliationState = {
                isActivated: state.isActivated === true,
                hasOpenReconciliation: state.hasOpenReconciliation === true,
                currentReconciliationId: state.currentReconciliationId ?? null,
                loading: state.loading === true,
                error: state.error === true,
            };

            $rootScope.$evalAsync();
        },
    });
    return Club;
}

export default ClubService;
